import { MARKS } from "@contentful/rich-text-types";
import { Box, SxProps } from "@mui/material";
import { Maybe } from "graphql/jsutils/Maybe";
import { Claim } from "../../models/schema";
import { colors } from "../../theme/colors";
import { generateId } from "../../utils/utilities";
import { AnimatedView } from "../utils/AnimatedView";
import RenderContent from "../utils/RenderContent";

type Props = {
  claims?: Array<Maybe<Claim>>;
  sx?: SxProps;
  zIndex?: number;
};

export const ClaimsBanner = ({ claims, zIndex, sx = {} }: Props) => {
  return (
    <Box
      sx={{
        background: `radial-gradient(${colors.grey5}, ${colors.black})`,
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        justifyContent: { xs: "center", lg: "evenly" },
        alignItems: "center",
        pt: 20,
        pb: 20,
        px: { xs: 10, md: 20 },
        borderRadius: {
          xs: "100% 0% 100% 0% / 0% 80% 4% 100%",
          lg: "100% 0% 100% 0% / 0% 80% 10% 100%"
        },
        mb: -10,
        position: "relative",
        zIndex,
        ...sx
      }}>
      {claims?.map((claim, index) => (
        <AnimatedView
          sx={{ width: "100%" }}
          key={generateId(5)}
          animation="fadeIn"
          duration={500}
          delay={{
            xs: 0,
            md: index * 300
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              my: { xs: 5, lg: 0 },
              px: 5
            }}>
            <Box
              component="img"
              src={claim?.icon?.url as string}
              sx={{ maxWidth: { xs: 120, md: 150 }, mb: 5 }}
            />
            <RenderContent
              content={claim?.description?.json}
              sx={{ color: colors.white }}
              options={{
                renderMark: {
                  [MARKS.BOLD]: (text) => (
                    <Box component="span" color={colors.yellow} fontWeight="bold">
                      {text}
                    </Box>
                  )
                }
              }}
            />
          </Box>
        </AnimatedView>
      ))}
    </Box>
  );
};
